import { Component, Input, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { GrowthToolkitClient, GrowthToolkitKPI, PracticeKpiData, PracticeMetric } from 'src/app/shared/services/ppv.api'

@Component({
   selector: 'vc-hospital-kpi-row',
   templateUrl: './hospital-kpi-row.component.html',
   styleUrls: ['./hospital-kpi-row.component.scss'],
   standalone: false,
})
export class HospitalKPIRowComponent {
   @Input() practiceSKey: any
   @Input() showHospitalName: boolean
   @Input() showMeeting: boolean
   @Input() showChart: boolean
   hospitalRow: any = null

   //the metrics (action items) being tracked in this practice
   practiceMetrics: PracticeMetric[] = []

   //the main KPIs tracked in the GrowthToolkit
   kpis: GrowthToolkitKPI[] = []

   //the raw list of KPI data for this particular practice
   kpiData: PracticeKpiData[] = []

   //the KPI data reduced into a map for access by kpiId
   //for use by the html template
   kpiDataMap: { [key: number]: PracticeKpiData }

   constructor(private growthToolkitClient: GrowthToolkitClient, private route: ActivatedRoute) {}

   ngOnInit(): void {
      if (this.practiceSKey) {
         this.fetchHospitalRow()
         this.fetchKPIs()
         this.fetchKpiData()
         this.fetchMetricData()
      }
   }

   public fetchHospitalRow(): void {
      this.growthToolkitClient.getAvailablePractices(this.practiceSKey).subscribe({
         next: (data) => {
            this.hospitalRow = data[0]
         },
         error: (error) => {
            console.error('Error fetching hospital data: ', error)
         },
      })
   }

   public fetchKpiData(): void {
      this.growthToolkitClient.getKpiData(this.practiceSKey).subscribe({
         next: (data) => {
            this.kpiData = data

            //populate the kpiDataMap for use in the html template
            this.kpiDataMap = this.kpiData.reduce((acc, item) => {
               if (item.kpiId != null) {
                  acc[item.kpiId] = item
               }
               return acc
            }, {} as { [key: number]: PracticeKpiData })

            // console.log('KPI Data:', this.kpiData)
         },
         error: (error) => {
            console.error('Error fetching hospital KPI data: ', error)
         },
      })
   }

   public fetchMetricData(): void {
      this.growthToolkitClient.getMetricsForPractice(this.practiceSKey).subscribe({
         next: (data) => {
            this.practiceMetrics = data
            // console.log(this.practiceMetrics)
         },
         error: (error) => {
            console.error('Error fetching hospital metric data: ', error)
         },
      })
   }

   getGoalsSummary(): { met: number; total: number } {
      let met = 0
      let total = 0

      //TODO: we need to populate the metric.currentValue here from the various custom datasources
      //so like it would be the current hours open for the practice per week or the current adspend dollars per week etc

      for (const metric of this.practiceMetrics) {
         if (metric.isActive && metric.targetValue && metric.currentValue) {
            total++
            if (metric.currentValue >= metric.targetValue) {
               met++
            }
         }
      }
      return { met, total }
   }

   public fetchKPIs(): void {
      this.growthToolkitClient.getKPIs().subscribe({
         next: (data) => {
            this.kpis = data
         },
         error: (error) => {
            console.error('Error fetching KPIs: ', error)
         },
      })
   }
}
